export var AttachmentMIMEType;
(function (AttachmentMIMEType) {
    AttachmentMIMEType["PNG"] = "image/png";
    AttachmentMIMEType["JPEG"] = "image/jpeg";
    AttachmentMIMEType["SVG"] = "image/svg+xml";
    AttachmentMIMEType["MP3"] = "audio/mpeg";
})(AttachmentMIMEType || (AttachmentMIMEType = {}));
export function getFileExtensionForAttachmentMIMEType(attachmentMimeType) {
    switch (attachmentMimeType) {
        case AttachmentMIMEType.JPEG:
            return "jpg";
        case AttachmentMIMEType.PNG:
            return "png";
        case AttachmentMIMEType.SVG:
            return "svg";
        case AttachmentMIMEType.MP3:
            return "mp3";
        default:
            return null;
    }
}
export function isAudioMIMEType(mimeType) {
    return mimeType.startsWith("audio/");
}
// An intentionally quick and dirty mime type extractor: the libraries which map extensions to mime types are several kB.
export function getAttachmentMIMETypeForFilename(filename) {
    const uppercaseFilename = filename.toUpperCase();
    if (uppercaseFilename.endsWith(".PNG")) {
        return AttachmentMIMEType.PNG;
    }
    else if (uppercaseFilename.endsWith(".JPG") ||
        uppercaseFilename.endsWith(".JPEG")) {
        return AttachmentMIMEType.JPEG;
    }
    else if (uppercaseFilename.endsWith(".SVG")) {
        return AttachmentMIMEType.SVG;
    }
    else if (uppercaseFilename.endsWith(".MP3")) {
        return AttachmentMIMEType.MP3;
    }
    else {
        return null;
    }
}
//# sourceMappingURL=attachmentReference.js.map